<!-- <mat-card class="subform-card w-100">
  <mat-card-header>
    <mat-card-title class="subform-group-title">
      {{ title ?? "SHARED.LOCALIZED_VALUE_SUBFORM.TITLE" | translate }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <ng-container [formGroup]="form">
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="30px"
        *ngFor="let key of getKeys(); let i = index"
      >
        <mat-form-field appearance="outline">
          <mat-label>
            {{ getNameByCode(key) | titlecase }}
            {{ "SHARED.LOCALIZED_VALUE_SUBFORM.LOCALE_SUBFIX" | translate }}
          </mat-label>
          <textarea
            matInput
            [formControlName]="key"
            cdkTextareaAutosize
            [cdkAutosizeMinRows]="textareaAutosizeMinRows"
          >
          </textarea>
          <mat-hint>{{
            "SHARED.LOCALIZED_VALUE_SUBFORM.REQUIRED" | translate
          }}</mat-hint>
          <mat-error *ngIf="getServerError(key)">
            {{ getServerError(key) }}
          </mat-error>
        </mat-form-field>
      </div>
    </ng-container>
  </mat-card-content>
</mat-card> -->

<ng-container [formGroup]="form">
  <mat-form-field appearance="outline">
    <mat-label>
      {{ title ?? "SHARED.LOCALIZED_VALUE_SUBFORM.TITLE" | translate }}
    </mat-label>
    <input matInput formControlName="hun" />
    <mat-hint>{{ "REQUIRED" | translate }}</mat-hint>
    <mat-error *ngIf="getServerError('hun')">
      {{ getServerError("hun") }}
    </mat-error>
  </mat-form-field>
</ng-container>
